import { useState } from 'react';

const TYPE_LABEL = { fact: 'حقیقت', playbook: 'دستورالعمل', faq: 'سؤال متداول' };

export default function NoteCard({ note, agent, onChanged, onShowHistory }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(note.content);
  const [saving, setSaving] = useState(false);
  const [confirmingDelete, setConfirmingDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await agent.api.updateNote(note.id, { content: draft, type: note.type, category: note.category });
      await onChanged();
      setEditing(false);
    } finally { setSaving(false); }
  };

  const archive = async () => {
    await agent.api.archiveNote(note.id);
    await onChanged();
  };

  const restore = async () => {
    await agent.api.restoreNote(note.id);
    await onChanged();
  };

  // Permanent delete. Only offered on archived notes — the two-stage path
  // (Active → Archive → Delete) prevents one-click loss of an active note.
  const remove = async () => {
    setDeleting(true);
    try {
      await agent.api.deleteNote(note.id);
      await onChanged();
    } finally {
      setDeleting(false);
      setConfirmingDelete(false);
    }
  };

  return (
    <div className={`note-card${note.flagged_reason ? ' flagged' : ''}`}>
      {editing ? (
        <textarea value={draft} onChange={(e) => setDraft(e.target.value)} />
      ) : (
        <div>{note.content}</div>
      )}
      {note.flagged_reason && (
        <div style={{ color: '#b45309', fontSize: 12, marginTop: 5 }}>⚠ {note.flagged_reason}</div>
      )}
      <div className="note-meta">
        <span>{TYPE_LABEL[note.type] || note.type}</span>
        <span>دسته: {note.category}</span>
      </div>
      <div className="note-actions">
        {editing ? (
          <>
            <button className="consultant-btn" onClick={save} disabled={saving}>
              {saving ? 'در حال ذخیره…' : 'ذخیره'}
            </button>
            <button className="consultant-btn secondary" onClick={() => { setEditing(false); setDraft(note.content); }}>
              انصراف
            </button>
          </>
        ) : (
          <>
            <button className="consultant-btn secondary" onClick={() => setEditing(true)}>ویرایش</button>
            <button className="consultant-btn secondary" onClick={() => onShowHistory(note)}>تاریخچه</button>
            {note.status === 'active'
              ? <button className="consultant-btn secondary" onClick={archive}>بایگانی</button>
              : (
                <>
                  <button className="consultant-btn secondary" onClick={restore}>بازگردانی</button>
                  <button className="consultant-btn danger" onClick={() => setConfirmingDelete(true)}>
                    حذف نهایی
                  </button>
                </>
              )}
          </>
        )}
      </div>

      {confirmingDelete && (
        <div className="modal-backdrop" onClick={() => !deleting && setConfirmingDelete(false)}>
          <div className="modal-box confirm-box" onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: 16, color: '#0f172a' }}>حذف نهایی نت؟</h3>
            <p style={{ margin: '0 0 6px 0', color: '#475569', fontSize: 13, lineHeight: 1.85 }}>
              این عمل برگشت‌ناپذیر است. خودِ نت و کلِ تاریخچهٔ ویرایش‌هایش پاک می‌شوند.
              اگر فقط می‌خواهی از مشاور هوشمند مخفی شود، «بازگردانی» را لغو کن و
              همین بایگانی کافی است.
            </p>
            <div className="confirm-preview">{note.content}</div>
            <div className="confirm-actions">
              <button
                className="consultant-btn secondary"
                onClick={() => setConfirmingDelete(false)}
                disabled={deleting}
              >
                انصراف
              </button>
              <button
                className="consultant-btn danger"
                onClick={remove}
                disabled={deleting}
              >
                {deleting ? 'در حال حذف…' : 'بله، برای همیشه حذف کن'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
